import api from "../../api";
import { filterTransactionEndPoint } from "../../api/apisUrl";
import { FilterTransactionDetails } from "../../models";
import {
  GET_FILTER_TRANSACTION_FAILD,
  GET_FILTER_TRANSACTION_SUCCESS,
  GET_FILTER_TRANSACTION_LOADING,
  GET_FILTER_TRANSACTION_RESET,
} from "../types";

export const filterTransaction = (
  token: string,
  fiterDetails: FilterTransactionDetails,
  pageNumber: any,
  merchantId?: string,
  outletId?: string,
  userId?: string,
  partnerIds?: string[],
) => {
  return async (
    dispatch: (arg0: {
      type: string;
      loading?: boolean;
      payload?: any;
      status?: any;
      error?: any;
    }) => void,
  ) => {
    dispatch({ type: GET_FILTER_TRANSACTION_LOADING, loading: true });

    await api
      .get(
        filterTransactionEndPoint(
          fiterDetails,
          pageNumber,
          merchantId,
          userId,
          outletId,
          partnerIds,
        ),
        {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((res) => {
        dispatch({ type: GET_FILTER_TRANSACTION_LOADING, loading: false });
        dispatch({
          type: GET_FILTER_TRANSACTION_SUCCESS,
          payload: res.data,
          status: res.status,
          loading: false,
        });
      })

      .catch((err) => {
        dispatch({ type: GET_FILTER_TRANSACTION_FAILD, loading: false });

        if (err.response) {
          if (err.response.data.message) {
            dispatch({
              type: GET_FILTER_TRANSACTION_FAILD,
              status: err.status,
              error: err.response.data.message,
            });
          } else {
            dispatch({
              type: GET_FILTER_TRANSACTION_FAILD,
              status: err.status,
              error:
                "Something error !! Please contact the technical administrator.",
            });
          }
        } else if (err.request) {
          dispatch({
            type: GET_FILTER_TRANSACTION_FAILD,
            error: "Something error in your request !!",
          });
        } else {
          dispatch({
            type: GET_FILTER_TRANSACTION_FAILD,
            error:
              "Something error !! Please contact the technical administrator.",
          });
        }
      });
  };
};

export const resetFilterTransaction = () => {
  return {
    type: GET_FILTER_TRANSACTION_RESET,
  };
};
